// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IeUc","importantInfo":"styles_importantInfo__1QOvD"};